
const digest = '8c069ab6d8cf28c0371b417474d8ee4930f51db713892068a578d021a1ea8bdc';
const classes = {"wrapper":"_wrapper_1ivoj_1"};
const css = `._wrapper_1ivoj_1 {
  background: #f2f4f7;
  border: 1px solid #eaedf3;
  border-left: 0;
  border-right: 0;
  padding: 34px 24px;
  margin: -34px -24px 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  